import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { CPanel, H4, Text } from '@appcues/component-library';

import Loader from 'components/Common/Loader';
import Table from 'components/Common/UI/Table';
import SelectProfileAttribute from 'components/Common/SelectProfileAttribute';
import { updateAccountMeta } from 'actions/account/meta';
import { selectAccountMeta } from 'reducers/account/meta';
import UserSampleTableUserCell from './UserSampleTableUserCell';

export function UserSampleTable({
  title = '10 MOST RECENT USERS',
  timestampHeader = 'Timestamp',
  emptyStateText = 'No users seen yet',
  onSave,
  userSample,
  userNameField,
}) {
  const handleProfileAttributeColumnChange = field => {
    onSave({ userNameField: field.value });
  };

  const userSampleRows =
    userSample.meta.synced && !userSample.meta.errored ? userSample.data : [];

  const loaded = userSample.meta.synced;
  const usersExist =
    userSample.meta.synced &&
    !userSample.meta.errored &&
    userSample.data.length > 0;

  return (
    <CPanel>
      <H4 type="tertiary">{title}</H4>
      {loaded && usersExist && (
        <Table
          panel
          defaultSortColumn="timestamp"
          containerStyles={{ marginTop: 20 }}
          columns={[
            {
              Header: () => {
                return (
                  <SelectProfileAttribute
                    value={userNameField}
                    onChange={handleProfileAttributeColumnChange}
                  />
                );
              },
              accessor: 'user_id',
              Cell: ({ value }) => {
                return (
                  <UserSampleTableUserCell
                    userId={value}
                    profileAttributeColumn={userNameField}
                  />
                );
              },
            },
            {
              Header: timestampHeader,
              accessor: 'timestamp',
              sortable: true,
              Cell: ({ value }) =>
                value ? moment.utc(value).local().format('lll') : '-',
            },
          ]}
          data={userSampleRows}
        />
      )}
      {loaded && !usersExist && (
        <Text type="tertiary" marginY={32}>
          {emptyStateText}
        </Text>
      )}
      {!loaded && <Loader margin="2rem" />}
    </CPanel>
  );
}

UserSampleTable.propTypes = {
  userSample: PropTypes.shape({
    meta: {
      fetching: PropTypes.bool,
      synced: PropTypes.bool,
      errored: PropTypes.bool,
    },
    data: PropTypes.arrayOf(
      PropTypes.shape({
        user_id: PropTypes.string,
        timestamp: PropTypes.string,
      })
    ),
  }),
  title: PropTypes.string,
  timestampHeader: PropTypes.string,
  emptyStateText: PropTypes.string,
  onSave: PropTypes.func,
};

function mapStateToProps(state) {
  const accountMeta = selectAccountMeta(state);
  const { userNameField } = accountMeta;

  return {
    userNameField,
  };
}

const mapDispatchToProps = {
  onSave: updateAccountMeta,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSampleTable);
